export const determineTenant = () => {
    const host = window.location.hostname.toLowerCase();
    const isLocalHost = host === 'localhost' || host === '127.0.0.1' || host === '::1';

    if (
        window.location.origin.toLowerCase().indexOf('investceo') >= 0 ||
        isLocalHost
    ) {
        return 'investceo';
    }
    return 'alm';
}
